import React from 'react';

import { CheckboxCheckIcon } from 'app/components/shared/icons';
import { useFormikContext } from 'formik';

import {
  ResourceSubmissionFieldTitle,
  ResourceSubmissionFormFieldContainer,
  ResourceSubmissionFormFieldWrapper,
  ResourceSubmissionFieldSubtitle,
  ResourceSubmissionFieldCheckboxWrapper,
  ResourceSubmissionFieldCheckboxContainer,
  ResourceSubmissionFieldCheckbox,
  ResourceSubmissionFieldCheckboxBackground,
  ResourceSubmissionFieldCheckboxLabel,
  ResourceSubmissionFieldInitiativeContainer,
} from '../styled';

interface ResourceSubmissionPaywallAccessProps {
  disabled?: boolean;
}

export default function ResourceSubmissionPaywallAccess({
  disabled = false,
}: ResourceSubmissionPaywallAccessProps) {
  const formikContext = useFormikContext();
  const hasPaywall = (formikContext.values as any).has_paywall;

  const handlePaywallChange = (value: boolean) => {
    if (disabled) return;

    if (!(formikContext.touched as any).has_paywall) {
      formikContext.setFieldTouched('has_paywall', true);
    }
    formikContext.setFieldValue('has_paywall', value);
  };

  return (
    <ResourceSubmissionFormFieldWrapper>
      <ResourceSubmissionFieldTitle>
        Is there a paywall to access this?
      </ResourceSubmissionFieldTitle>
      <ResourceSubmissionFormFieldContainer>
        <ResourceSubmissionFieldSubtitle>Required</ResourceSubmissionFieldSubtitle>
        <ResourceSubmissionFieldInitiativeContainer>
          <ResourceSubmissionFieldCheckboxWrapper>
            <ResourceSubmissionFieldCheckboxContainer>
              <ResourceSubmissionFieldCheckbox
                type="checkbox"
                disabled={disabled}
                checked={hasPaywall === true}
                onChange={() => handlePaywallChange(true)}
              />
              <ResourceSubmissionFieldCheckboxBackground>
                {hasPaywall === true && <CheckboxCheckIcon fill="var(--color-primary)" />}
              </ResourceSubmissionFieldCheckboxBackground>
            </ResourceSubmissionFieldCheckboxContainer>
            <ResourceSubmissionFieldCheckboxLabel>Yes</ResourceSubmissionFieldCheckboxLabel>
          </ResourceSubmissionFieldCheckboxWrapper>
          <ResourceSubmissionFieldCheckboxWrapper>
            <ResourceSubmissionFieldCheckboxContainer>
              <ResourceSubmissionFieldCheckbox
                type="checkbox"
                disabled={disabled}
                checked={hasPaywall === false}
                onChange={() => handlePaywallChange(false)}
              />
              <ResourceSubmissionFieldCheckboxBackground>
                {hasPaywall === false && <CheckboxCheckIcon fill="var(--color-primary)" />}
              </ResourceSubmissionFieldCheckboxBackground>
            </ResourceSubmissionFieldCheckboxContainer>
            <ResourceSubmissionFieldCheckboxLabel>No</ResourceSubmissionFieldCheckboxLabel>
          </ResourceSubmissionFieldCheckboxWrapper>
        </ResourceSubmissionFieldInitiativeContainer>
      </ResourceSubmissionFormFieldContainer>
    </ResourceSubmissionFormFieldWrapper>
  );
}
